import { Injectable } from '@angular/core';
import { CrudService } from '@appstrax/services/database';
import { ProjectInvite } from '@models';

@Injectable({ providedIn: 'root' })
export class ProjectInviteService extends CrudService<ProjectInvite> {
  constructor() {
    super('project-invites', ProjectInvite);
  }
}

